import type { CapabilityState } from "../domain/model";

const marks: Record<CapabilityState, string> = {
  DISCOVERED: "01",
  LEARNING: "02",
  UNDERSTOOD: "03",
  BUILT: "04",
  SHIPPED: "05",
  EVIDENCED: "06",
  DEFENDED: "07",
};

export function CapabilityMark({ state, compact = false }: { state: CapabilityState; compact?: boolean }) {
  return (
    <span className={`capability-mark state-${state.toLowerCase()}`} title={state}>
      <span aria-hidden="true">{marks[state]}</span>
      {!compact && <strong>{state}</strong>}
    </span>
  );
}
